import {
  BOUTIQUE_DEVELOPERS_PATH,
  DEALERS_PATH,
  TRADE_PARTNER_PATH,
  TRADE_PATH,
} from '@/consts/routes';

/** Desktop Trade mega-menu — image cards with labels and links. */
export const TRADE_NAV_MEGA_MENU = {
  items: [
    {
      itemKey: 'trade-program',
      label: 'Trade Program',
      href: TRADE_PATH,
      image: {
        src: '/imgs/nav/trade/trade-program.jpeg',
        alt: 'NIICO trade program cabinetry',
      },
    },
    {
      itemKey: 'trade-partner',
      label: 'Become a Dealer Partner',
      href: TRADE_PARTNER_PATH,
      image: {
        src: '/imgs/nav/trade/trade-partner.jpeg',
        alt: 'Interior designer reviewing NIICO millwork',
      },
    },
    {
      itemKey: 'boutique-developers',
      label: 'Multi-Unit Projects',
      href: BOUTIQUE_DEVELOPERS_PATH,
      image: {
        src: '/imgs/nav/trade/boutique-developers.jpeg',
        alt: 'Luxury kitchen for boutique development project',
      },
    },
    {
      itemKey: 'dealers',
      label: 'Dealers',
      href: DEALERS_PATH,
      image: {
        src: '/imgs/nav/trade/dealers.jpeg',
        alt: 'NIICO showroom cabinetry for dealers',
      },
    },
  ],
};

/** Flat links for mobile drawer under Trade. */
export const TRADE_NAV_DRAWER_LINKS = TRADE_NAV_MEGA_MENU.items.map(({ label, href }) => ({
  label,
  href,
}));

export function getTradeNavHrefs() {
  return TRADE_NAV_MEGA_MENU.items.map(item => item.href);
}
